/* Prévisions des ventes, l'écran A3 (décisions d'Olivier, 2026-10-21 et 2026-10-22 ; brief
   `WIP/briefs/previsions-a3.md`, proto `WIP/protos/previsions-alt-a3v4-totaux.html`).
   Ici, ce qui se calcule sans écran : lire une ligne de la vue selon le flux affiché, passer d'un
   cumul tapé à un mois, sommer le réalisé, en tirer le tarif moyen. */

export const MOIS_12 = Array.from({ length: 12 }, (_, i) => i);
export const nul12 = () => Array(12).fill(null);

/* Somme des mois `idx` (tous par défaut) ; null quand aucun n'est connu : l'inconnu n'est pas zéro. */
export function sumNN(arr, idx = MOIS_12) {
  if (!arr) return null;
  const xs = idx.map((i) => arr[i]).filter((v) => v != null);
  return xs.length ? xs.reduce((a, b) => a + b, 0) : null;
}

/* Le cumul mois après mois ; un mois reste inconnu (null) tant qu'aucun mois n'a été connu. */
export function cumNN(arr) {
  if (!arr) return null;
  let t = 0;
  let has = false;
  return arr.map((v) => {
    if (v != null) has = true;
    if (has) t += v || 0;
    return has ? t : null;
  });
}

/* En saisie CUMULÉE, la valeur tapée sur un mois est un cumul : le mois à enregistrer est ce cumul moins
   les mois d'avant, tels qu'ils sont. En saisie mensuelle, la valeur tapée est le mois. */
export function versMensuel(tape, mensuels, i, cumule) {
  if (tape == null) return null;
  if (!cumule) return tape;
  let avant = 0;
  for (let j = 0; j < i; j += 1) avant += (mensuels && mensuels[j]) || 0;
  return Math.round((tape - avant) * 10000) / 10000;
}

/* « Afficher » : le total (portefeuille + nouvelles ventes), l'un ou l'autre. Ce qu'on tape sur le total
   se corrige sur les nouvelles ventes, le serveur le dit par `flux = 'total'`. */
export function serieFlux(l, mode) {
  if (mode === 'bk') {
    return { qty: l.backlog, val: l.bk_months, ca: l.parts.bk.ca, bill: l.parts.bk.billing, formes: l.backlog_forms,
             flux: 'bk', champ: 'backlog' };
  }
  if (mode === 'new') {
    return { qty: l.new_quantities, val: l.new_months, ca: l.parts.new.ca, bill: l.parts.new.billing, formes: l.new_forms,
             flux: 'new', champ: 'new' };
  }
  return { qty: l.quantities, val: l.months, ca: l.ca, bill: l.billing, formes: l.new_forms, flux: 'total', champ: 'total' };
}

/* La règle du flux qui reçoit la saisie : celle des nouvelles ventes sur le total, sinon celle du flux affiché. */
export const regleSaisie = (l, mode) => (l.effective_rules || {})[mode === 'bk' ? 'bk' : 'new'] || 'linear';

/* Le tarif moyen réalisé : le facturé sur le volume, des mois où l'un et l'autre sont connus. */
export function tarifMoyen(fact, vol) {
  let f = 0;
  let v = 0;
  MOIS_12.forEach((i) => {
    if (fact && vol && fact[i] != null && vol[i] != null && vol[i] > 0) { f += fact[i]; v += vol[i]; }
  });
  return v > 0 ? f / v : null;
}

/* Le tarif de chaque mois : le facturé sur le volume du mois ; en cumulé, sur leurs cumuls des seuls mois
   où l'un et l'autre sont connus (un facturé sans volume ne fait pas un tarif). */
export function tarifsMois(fact, vol, cumule) {
  return MOIS_12.map((i) => {
    if (!fact || !vol) return null;
    const mois = cumule ? MOIS_12.filter((j) => j <= i) : [i];
    let f = 0;
    let v = 0;
    mois.forEach((j) => { if (fact[j] != null && vol[j] != null && vol[j] > 0) { f += fact[j]; v += vol[j]; } });
    return v > 0 ? f / v : null;
  });
}

/* Le réalisé d'une ligne de planification : { ca, billing, volume } (null : inconnu). Une offre SANS ligne
   se prévoit d'un bloc : son réalisé est celui de l'offre, sans volume (un volume se tape sur une ligne). */
export function realLigne(realise, offre, ligne) {
  const o = (realise && realise.offers && realise.offers[offre.offer_id]) || null;
  if (!o) return { ca: null, billing: null, volume: null };
  if (!offre.has_lines || !ligne.line_id) return { ca: o.ca, billing: o.billing, volume: null };
  const l = (o.lines || {})[ligne.line_id];
  return l ? { ca: l.ca, billing: l.billing, volume: l.volume } : { ca: null, billing: null, volume: null };
}

/* Le réalisé d'une offre : { ca, billing, nonAffecte: { ca, billing } }. Le non affecté est ce qu'aucune
   ligne ne porte ; une offre sans ligne n'en a pas. */
export function realOffre(realise, offre) {
  const o = (realise && realise.offers && realise.offers[offre.offer_id]) || null;
  if (!o) return { ca: null, billing: null, nonAffecte: { ca: null, billing: null } };
  return { ca: o.ca, billing: o.billing, nonAffecte: offre.has_lines ? o.unassigned || { ca: null, billing: null } : { ca: null, billing: null } };
}
